import React, { useEffect, useState, useCallback } from "react";
import "../styles/Galary.css"; // Import the CSS for styling

// Keep your image imports the same
const images = [
    // ... your image require statements
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.34.57.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.35.34.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.37.05.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.37.23.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.38.05.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.38.40.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.39.16.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.39.50.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.40.18.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.41.58.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.42.27.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.44.04.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.45.02.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.47.12.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.48.39.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.53.24 (1).jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.53.24.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.56.47.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 16.58.22.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 17.01.26.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 17.03.54.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 17.08.07.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 17.08.36.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 17.08.58.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 17.10.01.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-19 at 16.20.04.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-19 at 16.25.07.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-19 at 16.16.07.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-19 at 16.25.42.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-19 at 16.27.20.jpeg"),
    require("../assets/galerie_bilder/WhatsApp Image 2026-01-16 at 17.13.50.jpeg"),
];

const Slideshow = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    // --- Callbacks and Effects (Keep as before) ---
    const nextSlide = useCallback(() => {
        setCurrentIndex((prevIndex) =>
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
    }, []);

    const prevSlide = useCallback(() => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 4000);
        return () => clearInterval(interval);
    }, [nextSlide]);

    const calculateTransform = () => {
        const slideWidthPercent = 80;
        const slideMarginPercent = 2;
        const totalSlideSpacePercent = slideWidthPercent + (slideMarginPercent * 2);
        const targetStartPercent = (100 - slideWidthPercent) / 2;
        const offset = `calc(${targetStartPercent}% - ${currentIndex * totalSlideSpacePercent}%)`;
        return `translateX(${offset})`;
    };

    // --- Updated Return Statement ---
    return (
        // Added a wrapper div for the whole section
        <div className="gallery-section">
            {/* Added the heading */}
            <h2 className="gallery-heading">Galerie</h2>

            {/* Existing slideshow container */}
            <div className="slideshow-container">
                <div
                    className="slides-wrapper"
                    style={{ transform: calculateTransform() }}
                >
                    {images.map((image, index) => (
                        <div
                            className={`slide ${index === currentIndex ? "active" : ""}`}
                            key={index}
                        >
                            <img
                                src={image}
                                alt={`Gallery view ${index + 1}`}
                                className="slide-image"
                            />
                        </div>
                    ))}
                </div>

                {/* Navigation Buttons */}
                <button className="prev" onClick={prevSlide} aria-label="Previous Slide">&#10094;</button>
                <button className="next" onClick={nextSlide} aria-label="Next Slide">&#10095;</button>

                {/* Dots Indicator */}
                <div className="dots-container">
                    {images.map((_, index) => (
                        <button
                            key={index}
                            className={`dot ${index === currentIndex ? "active" : ""}`}
                            onClick={() => setCurrentIndex(index)}
                            aria-label={`Go to slide ${index + 1}`}
                        >
                            <span className="sr-only">Go to slide {index + 1}</span>
                        </button>
                    ))}
                </div>
            </div>
        </div> // Closing the wrapper div
    );
};

export default Slideshow;